import React from 'react';
import { useParams } from 'react-router';

import type { Currency } from '@swf/core/enums';
import { Loader } from '@swf/poker';

import type { Props } from '../Container';
import useGetRecentTournamentsPlayerResults from '../hooks/useGetRecentTournamentsPlayerResults';

import NoResults from './NoResults/NoResults';
import styles from './Results.scss';
import ResultsTable from './ResultsTable/ResultsTable';
import Summary from './Summary/Summary';

const Results: React.FC<Props> = ({ loading }) => {
  const { clubId } = useParams<{ clubId: string }>();
  const { results, resultsLoading, summary } = useGetRecentTournamentsPlayerResults(Number(clubId));

  if (resultsLoading || loading) {
    return (
      <div className={styles.loading}>
        <Loader loading={resultsLoading} />
      </div>
    );
  }

  if (!summary) {
    return <NoResults />;
  }

  return (
    <div id="resultsTableContainer" className={styles.container}>
      <Summary tournamentSummary={summary} />
      {results && (
        <ResultsTable
          results={results}
          isPlayMoney={summary?.playMoney}
          currency={summary?.currency as Currency}
        />
      )}
    </div>
  );
};

export default Results;
